import React from "react";
import { Modal, Row, Col } from "react-bootstrap";

import Button from "../../../../shared/components/Buttons/Button";
import {
  buttonNameConstants,
  buttonTypeConstants,
} from "../../../../constants";

const ConfirmationModal = (props) => {
  const {
    size = "md",
    isConfirmationModal,
    isNoButton = true,
    handleNoButtonClick,
    noButtonText = buttonNameConstants.NO,
    yesButtonText = buttonNameConstants.YES,
    handleYesButtonClick,
    toggleConfirmationModal,
    message = "Are you sure you want to delete this item(s)?",
    isHtmlMessage = false,
    isLoading = false,
    isDiscardButton = false,
    handleDiscardButtonClick,
    discardButtonText = buttonNameConstants.DISCARD,
    yesButtonType = false,
    title,
  } = props;

  return (
    <Modal
      size={size}
      animation={true}
      centered
      backdrop="static"
      show={isConfirmationModal}
      onHide={toggleConfirmationModal}
      className={"nested-modal-z-index"}
      backdropClassName={"nested-modal-z-index"}
    >
      {title && (
        <Modal.Header closeButton className="pb-0">
          <Modal.Title className="d-flex align-items-center">
            <span>{title}</span>
          </Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>
        <Row className="m-0 p-0">
          <Col md={12} className="m-0 pe-0">
            <Row className="m-0 p-0 h-100">
              <Col
                md={12}
                className={
                  isHtmlMessage
                    ? title
                      ? "p-0 mt-2 stolen-card-text pb-4 fs-5 text-start"
                      : "p-0 mt-2 stolen-card-text py-4 fs-5 text-start"
                    : "p-0 mt-2 stolen-card-text d-flex justify-content-center py-4 fs-4 text-start"
                }
              >
                {isHtmlMessage ? (
                  <div dangerouslySetInnerHTML={{ __html: message }} />
                ) : (
                  message
                )}
              </Col>
              <Col md={12} className="mt-auto p-0 d-flex gap-2 ">
                {isNoButton && (
                  <Button
                    type="button"
                    label={noButtonText}
                    buttonType={buttonTypeConstants.GHOST_BUTTON}
                    className="w-100"
                    handleClick={() => {
                      handleNoButtonClick();
                    }}
                    isDisabled={isLoading}
                  ></Button>
                )}
                {isDiscardButton && (
                  <Button
                    type="button"
                    label={discardButtonText}
                    className="w-100"
                    handleClick={handleDiscardButtonClick}
                    isDisabled={isLoading}
                  />
                )}
                <Button
                  type="button"
                  className={
                    isNoButton || isDiscardButton ? "w-100" : "mx-auto w-50"
                  }
                  handleClick={() => {
                    handleYesButtonClick();
                  }}
                  buttonType={yesButtonType ? yesButtonType : ""}
                  label={yesButtonText}
                  isDisabled={isLoading}
                  isLoading={isLoading}
                ></Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default ConfirmationModal;
